import { Helmet } from "react-helmet";
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Container,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Toolbar,
    Typography,
    Avatar,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import bannerBg from "../../../assets/images/home/home-banner-bg.svg";
import bannerImg from "../../../assets/images/home/banner-image.svg";
import planningImg from "../../../assets/images/home/planning.svg";
import saveImg from "../../../assets/images/home/save.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import cssVariables from "../../../theme/cssVariables";
import React, { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import AttachFilesDialog from "../../../components/workloadAndPerformance/AttachFilesDialog";
import { ReactComponent as TrashIcon } from "../../../assets/images/portfolio/trash-alt.svg";
import core from "../../../assets/images/competency/core.svg";
import coreBlack from "../../../assets/images/competency/core-black.svg";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import StarIcon from '@mui/icons-material/StarOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from "@mui/styles";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as DownIcon } from "../../../assets/images/competency/chevrons-down.svg";
import { ReactComponent as UpIcon } from "../../../assets/images/competency/chevrons-up.svg";
import competencyService from "../../../services/competency.service";
import Icon from '@mui/material/Icon';
import { grey } from '@mui/material/colors';
import { ReactComponent as KpiArrow } from "../../../icons/kpiArrow.svg";
import * as Util from "../../../services/global.service";
import { postAchievementAdd, getKpiFormList } from "../../../actions/achievement";
import InputForm from "../../../components/achievement/InputForm";
import AlertDialog from "../../../components/AlertDialog";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import MessageDialog from "../../../components/inbox/MessageDialog";

const useStyles = makeStyles({
    outlineGrayBtn: {
        height: '35px',
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    icon: {
        paddingRight: "10px"
    },
    fill: {
        '& > path': {
            fill: "black"
        },
        '& g > path': {
            fill: "black"
        },
    },
    blueBg: {
        background: "#4085C9",
    },
    purpleBg: {
        background: "#7580BD",
    },
    scroll: {
        '&::-webkit-scrollbar': {
            width: "4px",
            backgroundColor: "#C4C4C4",
            borderRadius: "10px",
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': "none",
            borderRadius: "10px",
            backgroundColor: "#EFEFEF"
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: "10px",
            '-webkit-box-shadow': "none",
            backgroundColor: "#C4C4C4",
        }
    }
});
const Ratings = styled(Rating)({
    '& .MuiRating-icon': {
        color: '#F7B254 !important',
    },
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    fill: {
        '& > path': {
            fill: "black"
        },
        '& g > path': {
            fill: "black"
        },
    },
};
const CompetencyDetail = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const navigate = useNavigate();
    const [query] = useSearchParams()
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isAttachFilesDialogOpen, openAttachFilesDialog] = React.useState(false);
    const [value, setValue] = React.useState(2.5);
    const [showMore, setShowMore] = React.useState(false);
    let { serial } = useParams();
    let { employee_id } = useParams();
    // dialog
    const [formType, setFormType] = React.useState("");
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [kpiFormList, setKpiFormList] = React.useState([]);
    const [kpiFormSelect, setKpiFormSelect] = React.useState("");
    const [formData, setFormData] = React.useState({
        formEvaluateID: "",
        name: "",
        description: "",
        startDate: new Date(),
        endDate: Util.subStractDate(new Date(), "add", 1),
        metric: "",
        metricCondition: "",
        metricUnit: "",
        metricValue: "",
        isLink: false,
        selectedGoals: [],
        selectedCompetencies: [],
    });

    const handlePreSelectForm = () => {
        handleOpenDialog("edit")
        let formatResp = {
            achievementSerial: "",
            name: "",
            description: "",
            startDate: new Date(),
            endDate: Util.subStractDate(new Date(), "add", 1),
            metric: "",
            metricCondition: "",
            metricUnit: "",
            metricUnitCustom: "",
            metricValue: "",
            isLink: true,
            selectedGoals: [],
            selectedCompetencies: [dataDetail?.competency?.serial],
        }
        setFormData(formatResp)
    }
    // on dialog backdrop click
    const backdropClick = (event) => {
        return false
    }
    const handleOpenDialog = (value) => {
        setFormType(value)
        openDialog(true);
    };

    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        setFormData({
            formEvaluateID: "",
            name: "",
            description: "",
            startDate: new Date(),
            endDate: Util.subStractDate(new Date(), "add", 1),
            metric: "",
            metricCondition: "",
            metricUnit: "",
            metricValue: "",
            isLink: false,
            selectedGoals: [],
            selectedCompetencies: [],
        });
    };
    const compareInputForm = (oldVal, newVal) => {
        const checkEveryElement = (a, b) => {
            return a.every((v, i) => v === b[i]);
        }
        let isEqual = true
        if (oldVal.description !== newVal.description) isEqual = false
        if (Util.formatDate(oldVal.endDate) !== newVal.endDate) isEqual = false
        if (Util.formatDate(oldVal.startDate) !== newVal.startDate) isEqual = false
        if (oldVal.isLink !== newVal.isLink) isEqual = false
        if (oldVal.metric !== newVal.metric) isEqual = false
        if (oldVal.metricCondition !== newVal.metricCondition) isEqual = false
        if (oldVal.metricUnit !== newVal.metricUnit) isEqual = false
        if (oldVal.metricValue !== newVal.metricValue) isEqual = false
        if (oldVal.name !== newVal.name) isEqual = false
        if (oldVal.selectedGoals.length !== newVal.selectedGoals.length && !checkEveryElement(oldVal.selectedGoals, newVal.selectedGoals)) {
            isEqual = false
        }
        if (oldVal.selectedCompetencies.length !== newVal.selectedCompetencies.length && !checkEveryElement(oldVal.selectedCompetencies, newVal.selectedCompetencies)) {
            isEqual = false
        }
        return isEqual
    }
    const handleCloseDialog = (values = null) => {
        if (values) {
            let isFormEqual = compareInputForm({ ...formData }, values)
            if (isFormEqual) {
                openDialog(false);
                setFormData({
                    formEvaluateID: "",
                    name: "",
                    description: "",
                    startDate: new Date(),
                    endDate: Util.subStractDate(new Date(), "add", 1),
                    metric: "",
                    metricCondition: "",
                    metricUnit: "",
                    metricValue: "",
                    isLink: false,
                    selectedGoals: [],
                    selectedCompetencies: [],
                });
            } else {
                handleDiscardDialog(true)
            }
        } else {
            openDialog(false);
            setFormData({
                formEvaluateID: "",
                name: "",
                description: "",
                startDate: new Date(),
                endDate: Util.subStractDate(new Date(), "add", 1),
                metric: "",
                metricCondition: "",
                metricUnit: "",
                metricValue: "",
                isLink: false,
                selectedGoals: [],
                selectedCompetencies: [],
            });
        }

    };
    const handleSubmitForm = (values) => {
        dispatch(postAchievementAdd(values)).then((resp) => {
            handleSuccessDialog()
            getDetail()
        }).catch(() => {
            seterrorText(t("label.pleaseTryAgain"));
            handleOpenFailedMessageDialog(true);
        })
    };
    const [isSuccessDialogOpen, setSuccessDialog] = React.useState(false);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [currentAchievementSerial, setCurrentAchievementSerial] = React.useState("");
    const handleSuccessDialog = () => {
        setSuccessDialog(true);
        handleCloseDialog();
    };
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleConfirmDeleteDialog = (val, serial) => {
        setCurrentAchievementSerial(serial)
        openConfirmDeleteDialog(val);
    };
    const handleAchievementDialog = () => {
        // openAttachFilesDialog(true)
        navigate(`/kpi/achievement?competency=${serial}`, { replace: false })
    }
    const [dataDetail, setDataDetail] = React.useState([]);
    useEffect(() => {
        getDetail()
        // handlePreSelectForm()
        // loadKpiForm()
    }, []);
    const getDetail = () => {
        competencyService.detailCompetency(serial, employee_id).then(
            (response) => {
                if (response !== null && response !== undefined) {
                    setDataDetail(response.data);
                } else {
                    // navigate('/404', { replace: false });
                }
            },
        );
    }
    const handleGoTo = (val) => {
        navigate(`/kpi/achievement/${val}`, { replace: false });
    }
    const [open, setOpen] = React.useState(false);
    const [id, setID] = React.useState({});

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };
    let showMores = (data, ids) => {
        setShowMore(data)
        let dataFilter = JSON.parse(JSON.stringify(id))
        dataFilter[ids] = data
        setID(dataFilter)
    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            // maxWidth: 300,
        },
    }));
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const dateDayFormat = (data) => {
        const language = localStorage.getItem("lang");
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(language === undefined || language === null || language === "" ? 'th-TH' : language, {
                year: '2-digit',
                month: 'short',
                day: 'numeric',
            })
            return dateTH
        }
    }
    const infoItems = ["line one", "line two"]
    const tip = infoItems.join('\n')

    let getName = (data) => {
        let dataMain = data.toLowerCase()
        let index = dataMain.search("<br")
        if (Util.formatData(data, false) !== false) {
            if (index >= 0) {
                return data.substr(0, index)
            } else {
                return data
            }
        }
        return ""
    }
    return (
        <>
            <Helmet>
                <title>HOME | KPI </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "background.default",
                    minHeight: "100%",
                    py: 3,
                }}
            >

                <Container maxWidth="xl">
                    <>
                        {dataDetail.is_owner === true ?
                            <Grid container pt={2} pb={2}>
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency`)}>{t('competency.myName')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency/seeall/${dataDetail?.competency?.competency_type?.code}/${dataDetail?.evaluate?.kpi_form?.kpi_form}`)}>{dataDetail?.competency?.competency_type?.name}</span> / <span style={styles.end} >{t('competency.competencyDictionary')}</span></Typography>
                            </Grid>
                            :
                            <Grid container pt={2} pb={2}>
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/team-member`)}>{t('competency.teamMember')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency/${employee_id}`)}>{dataDetail?.owner_profile?.fullname}</span> / <span style={styles.end} >{t('competency.competencyDictionary')}</span></Typography>
                            </Grid>
                        }
                        <Grid container spacing={2}>
                            <Grid item lg={12} md={12} xs={12}>
                                <Grid container item my={3} mt={0}>
                                    <Grid item md={6} pr={1}>
                                        <Typography variant="h1" fontSize={36} color="#404349">
                                            {t('competency.competencyDictionary')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item lg={6} md={6} xs={12}>
                                <Card sx={{ height: 1 }}>
                                    <CardContent>
                                        <Grid container spacing={5} padding={1}>
                                            <Grid item xs={12}>
                                                <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
                                                    <Box display="flex" alignItems="center">
                                                        <Box mr={3}>
                                                            <div
                                                                className={`${classes.iconContainer}`}
                                                                style={{ background: dataDetail?.competency?.competency_type?.color }}
                                                            >
                                                                <Icon sx={{ color: "#ffffff" }}> {formatData(dataDetail?.competency?.competency_type?.icon, "")} </Icon>
                                                            </div>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                width: "100%",
                                                                minWidth: "100px",
                                                                wordWrap: "break-word",
                                                                display: "flex",
                                                                flexDirection: "column"
                                                            }}
                                                        >
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight="400" sx={{ color: "#AAAAAA" }}>
                                                                {formatData(dataDetail?.competency?.code, "-")}
                                                            </Typography>
                                                            <Typography fontSize={24} lineHeight="26.4px" fontWeight="600" color="#404349">
                                                                {formatData(dataDetail?.competency?.name, "-")}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        {dataDetail?.competency?.proficiency !== undefined && dataDetail?.competency?.proficiency !== null && dataDetail?.competency?.proficiency !== "" ?
                                                            <Box sx={{ background: "rgba(93, 161, 150, 0.1)", "border-radius": "5px", padding: "8px 10px", }}>
                                                                <Typography fontSize={16} fontWeight="400" variant="label" color="primary" >
                                                                    {t('competency.proficiency')}: {t('competency.level')} {formatData(dataDetail?.competency?.proficiency?.level, "-")}
                                                                </Typography>
                                                            </Box>
                                                            : null}
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", width: "100%" }} mt={4}>
                                                    {dataDetail?.competency?.is_evaluate ?
                                                        <Stack spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
                                                            <Ratings name="half-rating-read" value={formatData(Number(dataDetail?.competency?.exceeds_rating?.value).toFixed(1), 0)} precision={0.5} readOnly size="large" sx={{ fontSize: "50px" }} max={Number(formatData(dataDetail?.competency?.scale_level_min_max?.max, 5))} />
                                                            <Typography fontSize={18} lineHeight="27px" fontWeight="500" color="#404349">
                                                                {formatData(Number(dataDetail?.competency?.exceeds_rating?.value).toFixed(1), 0)} - {getName(formatData(dataDetail?.competency?.exceeds_rating?.description, ""))}
                                                            </Typography>
                                                        </Stack>
                                                        :
                                                        <Stack spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
                                                            <Rating name="half-rating-read" value={formatData(dataDetail?.competency?.exceeds_rating?.value, 0)} precision={0.5} readOnly size="large" sx={{ fontSize: "50px" }} max={Number(formatData(dataDetail?.competency?.scale_level_min_max?.max, 5))} />
                                                            <Typography fontSize={18} lineHeight="27px" fontWeight="400" color="#A3A3A3">
                                                                {t('competency.notYetEvaluated')}
                                                            </Typography>
                                                        </Stack>
                                                    }
                                                    <Box sx={{ border: "1px solid #DADADA", width: "250px", height: "40px", borderRadius: "3px", display: "flex", justifyContent: "center", alignItems: "center" }} mt={2}>
                                                        <Box>
                                                            <Typography fontSize={16} lineHeight="24px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.expectedRating')}:</Typography>
                                                        </Box>
                                                        {dataDetail?.competency?.expected_rating?.value !== undefined && dataDetail?.competency?.expected_rating?.value !== null && dataDetail?.competency?.expected_rating?.value !== "" ?
                                                            <Box sx={{ display: "flex", 'align-items': "center", paddingLeft: "5px" }}>
                                                                <Ratings fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={0.5} defaultValue={formatData(Number(dataDetail?.competency?.expected_rating?.value).toFixed(1), 0)} max={1} />
                                                                <Typography fontSize={18} pl="5px" pr="5px" fontWeight="400" color="#404349">
                                                                    {formatData(Number(formatData(dataDetail?.competency?.expected_rating?.value, "0")).toFixed(1), "0")}
                                                                </Typography>
                                                                <Box sx={{ position: "relative", paddingLeft: "5px" }}>
                                                                    {/* <ClickAwayListener onClickAway={handleTooltipClose}> */}
                                                                    <div style={{ cursor: "pointer", width: "max-content" }}>
                                                                        <BootstrapTooltip
                                                                            // onClose={handleTooltipClose}
                                                                            // open={open}
                                                                            // disableFocusListener
                                                                            // disableHoverListener
                                                                            // disableTouchListener
                                                                            placement="right"
                                                                            title={<span dangerouslySetInnerHTML={{ __html: formatData(dataDetail?.competency?.expected_rating?.description, "-") }} />}
                                                                        >
                                                                            {/* <TooltipIcon onClick={handleTooltipOpen} /> */}
                                                                            <TooltipIcon />
                                                                        </BootstrapTooltip>
                                                                    </div>
                                                                    {/* </ClickAwayListener> */}
                                                                </Box>
                                                            </Box>
                                                            :
                                                            <Box sx={{ display: "flex", 'align-items': "center", }}>
                                                                <Typography fontSize={18} pl="5px" pr="13px" fontWeight="400" color="#404349">
                                                                    {formatData(dataDetail?.competency?.expected_rating?.value, "-")}
                                                                </Typography>
                                                            </Box>
                                                        }

                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sx={{ paddingTop: "20px!important" }}>
                                                <Divider />
                                            </Grid>
                                            <Grid
                                                item
                                                p={2}
                                                lg={12}
                                                md={12}
                                                xs={12}
                                                sx={{ paddingTop: "20px!important" }}
                                            >
                                                <Grid container spacing={3} sx={{ padding: "5px 0px" }}>
                                                    {dataDetail?.competency?.proficiency !== undefined && dataDetail?.competency?.proficiency !== null && dataDetail?.competency?.proficiency !== "" ?
                                                        <>
                                                            <Grid item lg={4} md={4} xs={6}>
                                                                <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.proficiency')}</Typography>
                                                            </Grid>
                                                            <Grid item lg={8} md={8} xs={6} display="flex" alignItems="center" >
                                                                <Typography fontSize={18} lineHeight="25px" fontWeight="400" pr="10px" color="#404349">{t('competency.level')} {formatData(dataDetail?.competency?.proficiency?.level, "-")} - {formatData(dataDetail?.competency?.proficiency?.description, "-")}</Typography>
                                                                <Box sx={{ cursor: "pointer", position: "relative" }}>
                                                                    <div style={{ width: "max-content" }}>
                                                                        <BootstrapTooltip
                                                                            placement="right"
                                                                            arrow
                                                                            // title={formatData(dataDetail?.competency?.proficiency?.description, "-")}
                                                                            title={
                                                                                <div style={{ whiteSpace: 'pre-line' }}>
                                                                                    {dataDetail.list_proficiency.map((item) => (
                                                                                        <Typography fontSize={14} lineHeight="15.4px" fontWeight="300" sx={{ color: "#ffffff", padding: "4px 0" }}>
                                                                                            <span style={{ fontWeight: "500" }} >{t('competency.level')} {formatData(item?.level, "-")} </span>
                                                                                            - {formatData(item?.description, "-")}
                                                                                        </Typography>
                                                                                    ))}
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <TooltipIcon />
                                                                        </BootstrapTooltip>
                                                                    </div>
                                                                </Box>
                                                            </Grid>
                                                        </>
                                                        : null
                                                    }
                                                    <Grid item lg={4} md={4} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.description')}</Typography>
                                                    </Grid>
                                                    <Grid item lg={8} md={8} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349">{formatData(dataDetail?.competency?.description, "-")}</Typography>
                                                    </Grid>
                                                    <Grid item lg={4} md={4} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.competencyCode')}</Typography>
                                                    </Grid>
                                                    <Grid item lg={8} md={8} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349">{formatData(dataDetail?.competency?.code, "-")}</Typography>
                                                    </Grid>
                                                    <Grid item lg={4} md={4} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.competencyType')}</Typography>
                                                    </Grid>
                                                    <Grid item lg={8} md={8} xs={6} display="flex" alignItems="center" >
                                                        <div
                                                            className={`${classes.icon}`}
                                                        >
                                                            <Icon> {formatData(dataDetail?.competency?.competency_type?.icon, "")} </Icon>
                                                        </div>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349">
                                                            {formatData(dataDetail?.competency?.competency_type?.name, "-")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item lg={4} md={4} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.category')}</Typography>
                                                    </Grid>
                                                    <Grid item lg={8} md={8} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349">{formatData(dataDetail?.competency?.category, "-")}</Typography>
                                                    </Grid>
                                                    {dataDetail?.competency?.behavioral !== undefined && dataDetail?.competency?.behavioral !== null && dataDetail?.competency?.behavioral.length > 0 ?
                                                        <>
                                                            <Grid item lg={4} md={4} xs={6}>
                                                                <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.behaviors')}</Typography>
                                                            </Grid>
                                                            <Grid item lg={8} md={8} xs={6} sx={{ ".MuiTypography-root": { "&:before": { content: '""', width: "5px", height: "5px", background: "#000000", "border-radius": "50%", "margin-bottom": "4px", "margin-right": "10px", "margin-left": "10px", display: "inline-block", } } }}>
                                                                {dataDetail?.competency?.behavioral.map((item, index) => (
                                                                    // <BootstrapTooltip
                                                                    //     title={<span dangerouslySetInnerHTML={{ __html: formatData(item?.description, "-") }} />}
                                                                    //     placement="right">
                                                                    <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349" sx={{ width: "100%" }}>{formatData(item?.name, "")}</Typography>
                                                                    // </BootstrapTooltip>
                                                                ))}
                                                            </Grid>
                                                        </>
                                                        : null
                                                    }
                                                    <Grid item lg={4} md={4} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" sx={{ color: "#A3A3A3" }}>{t('competency.evaluationCycle')}</Typography>
                                                    </Grid>
                                                    <Grid item lg={8} md={8} xs={6}>
                                                        <Typography fontSize={18} lineHeight="25px" fontWeight="400" color="#404349">{formatData(dateDayFormat(dataDetail?.competency?.evaluate_cycle_start) + ' - ' + dateDayFormat(dataDetail?.competency?.evaluate_cycle_end), "-")}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Card sx={{ height: 1 }}>
                                            <CardContent>
                                                {/* header */}
                                                <Grid container pt={0} pb={0}>
                                                    <Grid item md={8} pr={1}>
                                                        <Typography fontSize={24} fontWeight="600" sx={{ paddingTop: "10px", paddingBottom: "10px" }} color="#404349">
                                                            {/* {t("portfolio.label.myWorkloadDetail")} */}
                                                            {t('competency.achievementActivities')} ({formatData(dataDetail?.competency?.achievement_count, 0)})
                                                        </Typography>
                                                    </Grid>
                                                    {dataDetail.is_owner &&
                                                        <Grid
                                                            item
                                                            md={4}
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="flex-end"
                                                        >
                                                            <Box ml={1} p={0}>
                                                                <Button size="small" variant="outlined" color="black" className={classes.outlineGrayBtn} onClick={() => handlePreSelectForm()}>
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                    >
                                                                        <PlusIcon className={classes.plusSvg} />
                                                                        {/* <Typography sx={{ marginLeft: "3px", color: 'black!important' }}> */}
                                                                        {/* {t("addfile")} */}
                                                                        <Box style={{ marginLeft: "3px", fontSize: "15px", "text-transform": "none", color: "#404349" }}>
                                                                            {t('label.add')}
                                                                        </Box>
                                                                        {/* </Typography> */}
                                                                    </Box>
                                                                </Button>
                                                            </Box>
                                                        </Grid>

                                                    }
                                                    <Grid item lg={12} sx={{ paddingTop: "10px!important" }}>
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                                {/* end header */}
                                                {/* content */}
                                                {
                                                    dataDetail.achievement !== undefined && dataDetail.achievement !== null && dataDetail.achievement.length > 0 ?
                                                        dataDetail.achievement.map(item => {
                                                            return (
                                                                <Grid container mt="20px">
                                                                    <Grid item xs={12}>
                                                                        <Paper elevation={2} sx={{ "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.15)" }}>
                                                                            <Grid container item p={2} display="flex" alignItems="center">
                                                                                <Grid item md={6} pr={1}>
                                                                                    <Grid container item p={0}>
                                                                                        <Grid item pr={1}>
                                                                                            <Typography fontSize={18} lineHeight="21px" fontWeight={400} color="#404349">
                                                                                                {item?.name}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    flexDirection="row-reverse"
                                                                                    md
                                                                                >
                                                                                    <Box ml={1} p={0} className="clickable" onClick={() => handleGoTo(item.serial)}>
                                                                                        <BootstrapTooltip title={t('label.viewDetail')} placement="top">
                                                                                            <KpiArrow style={{ cursor: "pointer" }} />
                                                                                        </BootstrapTooltip>
                                                                                    </Box>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Paper>
                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        }
                                                        ) :
                                                        (<Grid container spacing={2} mt={0}>
                                                            <Grid item lg={12} md={12}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    flexDirection="column"
                                                                    p={1}
                                                                >
                                                                    <Box>
                                                                        <img src={fileBrowser} alt="browser" />
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography variant="sub_label" >{t("competency.nodata")}</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>)
                                                }
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} mt={2}>
                                    <Grid item xs={12}>
                                        <Card sx={{ height: 1 }}>
                                            <CardContent>
                                                {/* header */}
                                                <Grid container pt={0} pb={0}>
                                                    <Grid item md={12} pr={1}>
                                                        <Typography fontSize={24} fontWeight="600" color="#404349" sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                                            {t("competency.evaluationFeedback")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ paddingTop: "10px!important" }}>
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                                {/* end header */}
                                                {/* content */}
                                                <Grid container sx={{ maxHeight: "527px", overflowY: dataDetail?.evaluate?.competency_feedback !== undefined && dataDetail?.evaluate?.competency_feedback !== null && dataDetail?.evaluate?.competency_feedback.length > 2 ? "scroll" : "none" }} className={`${classes.scroll}`}>
                                                    {
                                                        dataDetail?.evaluate?.competency_feedback !== undefined && dataDetail?.evaluate?.competency_feedback !== null && dataDetail?.evaluate?.competency_feedback.length > 0 ?
                                                            dataDetail?.evaluate?.competency_feedback.map(item => (
                                                                item?.exceeds_rating !== undefined && item?.exceeds_rating !== null && item?.exceeds_rating !== "" ?
                                                                    <Grid container mt={1}>
                                                                        <Grid item xs={12}>
                                                                            <Grid container item p={1}>
                                                                                <Grid item lg md xs={12}>
                                                                                    <Box display="flex" alignItems="center" width="100%">
                                                                                        <Box mr={2}>
                                                                                            <Avatar
                                                                                                src={formatData(item?.employee?.photo, "-")}
                                                                                                sx={{
                                                                                                    width: 50,
                                                                                                    height: 50,
                                                                                                }}
                                                                                            />
                                                                                        </Box>
                                                                                        <Box
                                                                                            sx={{
                                                                                                width: "100%",
                                                                                                minWidth: "100px",
                                                                                                wordWrap: "break-word",
                                                                                                display: "flex",
                                                                                                flexDirection: "column"
                                                                                            }}
                                                                                        >
                                                                                            <Typography fontSize={16} lineHeight="24px" fontWeight="500" color="#404349">
                                                                                                {formatData(item?.employee?.fullname, "-")} ({formatData(item?.employee?.position, "-")})
                                                                                            </Typography>
                                                                                            <Typography fontSize={14} lineHeight="21px" fontWeight="300" color="#404349">
                                                                                                {t('competency.evaluationCycle')}: {formatData(dataDetail?.evaluate?.kpi_form?.name, "-")}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Box>

                                                                                    <Box sx={{ display: "flex", justifyContent: "flex-start", flexDirection: "row", alignItems: "flex-start", width: "100%" }} mt={1}>
                                                                                        {item?.exceeds_rating !== undefined && item?.exceeds_rating !== null && item?.exceeds_rating !== "" ?
                                                                                            <Stack sx={{ justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
                                                                                                <Ratings name="half-rating-read" value={formatData(Number(item?.exceeds_rating?.value).toFixed(1), 0)} precision={0.5} readOnly size="large" max={Number(formatData(dataDetail?.competency?.scale_level_min_max?.max, 5))} />
                                                                                                <Typography fontSize={16} lineHeight="24px" fontWeight="400" pl={1} sx={{ color: "#A3A3A3" }}>
                                                                                                    {formatData(Number(item?.exceeds_rating?.value).toFixed(1), 0)} - {getName(formatData(item?.exceeds_rating?.description, ""))}
                                                                                                </Typography>
                                                                                            </Stack>
                                                                                            :
                                                                                            <Stack sx={{ justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
                                                                                                <Rating name="half-rating-read" value={formatData(Number(item?.exceeds_rating?.value).toFixed(1), 0)} precision={0.5} readOnly size="large" max={Number(formatData(dataDetail?.competency?.scale_level_min_max?.max, 5))} />
                                                                                            </Stack>
                                                                                        }
                                                                                    </Box>
                                                                                    <Grid container item sx={{ maxHeight: id[item.id] ? "auto" : "80px", overflow: id[item.id] ? "none" : "hidden" }} mt={2}>
                                                                                        <Typography fontSize={18} lineHeight="26.91px" color="#404349">
                                                                                            {formatData(item?.comment, "")}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid container item>
                                                                                        <Typography fontSize={14} lineHeight="20.913px" fontWeight={300} sx={{ color: "#A3A3A3" }} pt={2}>
                                                                                            {formatData(dateDayFormat(item?.updated_at), "-")}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    {item?.comment !== null && item?.comment !== "" ?
                                                                                        <Grid container item justifyContent="center" alignItems="center">
                                                                                            {id[item.id] ?
                                                                                                <Typography fontSize={14} lineHeight="24px" sx={{ textAlign: "center", textDecoration: "underline", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }} color="primary" onClick={e => showMores(false, item.id)}>
                                                                                                    {t('label.showLess')} <UpIcon />
                                                                                                </Typography>
                                                                                                :
                                                                                                <Typography fontSize={14} lineHeight="24px" sx={{ textAlign: "center", textDecoration: "underline", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }} color="primary" onClick={e => showMores(true, item.id)}>
                                                                                                    {t('label.showMore')} <DownIcon />
                                                                                                </Typography>
                                                                                            }
                                                                                        </Grid>
                                                                                        : null
                                                                                    }
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12} sx={{ paddingTop: "10px!important" }}>
                                                                            <Divider />
                                                                        </Grid>
                                                                    </Grid>
                                                                    :
                                                                    <Grid container spacing={2} mt={0}>
                                                                        <Grid item lg={12} md={12}>
                                                                            <Box
                                                                                display="flex"
                                                                                justifyContent="center"
                                                                                alignItems="center"
                                                                                flexDirection="column"
                                                                                p={1}
                                                                            >
                                                                                <Box>
                                                                                    <img src={fileBrowser} alt="browser" />
                                                                                </Box>
                                                                                <Box>
                                                                                    <Typography variant="sub_label">{t('competency.noEvaluationFeedback')}</Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                            )
                                                            ) : (<Grid container spacing={2} mt={0}>
                                                                <Grid item lg={12} md={12}>
                                                                    <Box
                                                                        display="flex"
                                                                        justifyContent="center"
                                                                        alignItems="center"
                                                                        flexDirection="column"
                                                                        p={1}
                                                                    >
                                                                        <Box>
                                                                            <img src={fileBrowser} alt="browser" />
                                                                        </Box>
                                                                        <Box>
                                                                            <Typography variant="sub_label">{t('competency.noEvaluationFeedback')}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>)
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                    <Dialog
                        onBackdropClick={backdropClick}
                        disableEscapeKeyDown
                        open={isAddDialogOpen}
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}
                        maxWidth="lg"
                        PaperProps={{ sx: { padding: "10px" } }}
                    >
                        <DialogTitle id="form-add-dialog-title" fontSize={24}>
                            {t("achievement.label.addNewAchievement")}
                        </DialogTitle>
                        <DialogContent px={0} pb={0}>
                            <Divider />
                            <InputForm
                                close={handleCloseDialog}
                                edit={handleSubmitForm}
                                data={formData}
                                type={formType}
                                form={Util.formatData(dataDetail?.evaluate?.kpi_form?.options?.cycle, "")}
                            ></InputForm>
                        </DialogContent>
                    </Dialog>
                    <SimpleDialog
                        open={isSuccessDialogOpen}
                        setValue={setSuccessDialog}
                        text={t("achievement.label.dialog.addAchievement")}
                    />
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        setValue={openSuccessAddDialog}
                        text={t("achievement.label.dialog.addAchievement")}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t("achievement.label.dialog.failed")}
                        text={errorText + t("achievement.label.dialog.again")}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />
                </Container>

            </Box>
        </>
    );
};
export default CompetencyDetail;
